import { useContext, useState } from 'react'
import { UploadFile } from 'antd'
import { AuthContext } from '../../../context/AuthProvider'
import { openErrorNotificationWithIcon } from '../../../helpers/utilities'

const validateObjectKeyInfo = ({
  obj,
  key,
  condition,
  handlerCb,
}: {
  obj: IfileContent
  key: 'pubkey' | 'signature' | 'deposit_data_root'
  condition: number
  handlerCb: (b: boolean) => void
}) => {
  if (key in obj) {
    if (obj[key].length !== condition) {
      handlerCb(true)
    }
  } else {
    handlerCb(true)
  }
}
export interface IfileContent {
  pubkey: string
  signature: string
  deposit_data_root: string
}

export const useFileUpload = () => {
  const [fileList, setFileList] = useState<UploadFile[]>([])
  const [error, setError] = useState<boolean>(false)

  const { setTransferData, transferData } = useContext(AuthContext)

  const beforeUpload = (file: any) => {
    if (file.type !== 'application/json') {
      setError(true)
      return false
    }
    const fileReader = new FileReader()
    fileReader.readAsText(file, 'UTF-8')
    fileReader.onload = (e) => {
      if (typeof e.target.result === 'string') {
        let parsedFile: IfileContent[]
        try {
          parsedFile = JSON.parse(e.target.result)
        } catch (er) {
          setError(true)
          return
        }
        if (Array.isArray(parsedFile)) {
          if (parsedFile.length > 500) {
            openErrorNotificationWithIcon('Validators max count should be 200')
            setError(true)
            return
          }
          if (parsedFile.length === 0) {
            setError(true)
            return
          }
          parsedFile.forEach((el: IfileContent) => {
            validateObjectKeyInfo({
              obj: el,
              key: 'pubkey',
              condition: 96,
              handlerCb: setError,
            })
            validateObjectKeyInfo({
              obj: el,
              key: 'signature',
              condition: 192,
              handlerCb: setError,
            })
            validateObjectKeyInfo({
              obj: el,
              key: 'deposit_data_root',
              condition: 64,
              handlerCb: setError,
            })
          })
          if (!error) {
            toggleFile(JSON.parse(e.target.result))
          }
        } else {
          setError(true)
        }
      }
    }
    setFileList([...fileList, file])

    return false
  }

  const toggleFile = (value: any) => {
    setTransferData(value)
  }

  return { beforeUpload, transferData, setError, toggleFile, error }
}
